export const GET_B_DEVICE_CSV_LOGS = 'GET_B_DEVICE_CSV_LOGS'
